import React, { ChangeEvent } from 'react';
import styled from '@emotion/styled';
import Markdown from '../Markdown/Markdown';
import { isIOS, isSafari } from '../../../utils';
import { ThemeProps } from '../../../types';

export interface CheckboxProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The error message to display
   */
  errorMessage?: string;
  /**
   * Id of the input
   */
  id: string;
  /**
   * Label for the input
   */
  label: string;
  /**
   * Name of the input
   */
  name: string;
  /**
   * Change event handler
   */
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  /**
   *  The checked value
   */
  value: boolean;
}

const Checkbox = ({
  className,
  errorMessage,
  id,
  label,
  name,
  onChange,
  value,
}: CheckboxProps) => {
  return (
    <div className={className}>
      <div>
        <input
          checked={value}
          id={id}
          name={name}
          onChange={onChange}
          type='checkbox'
        />
        <label htmlFor={id}>
          <Markdown>{label}</Markdown>
        </label>
      </div>
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  );
};

const StyledCheckbox = styled((props: any) => <Checkbox {...props} />)`
  ${({ errorMessage, theme }: { errorMessage: string; theme: ThemeProps }) => ({
    alignSelf: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 12,
    div: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'row',
    },
    "input[type='checkbox']": {
      marginTop: 3,
      outlineColor: errorMessage && theme.colors.error,
      outlineOffset: isIOS || isSafari ? '-2px' : 0,
      outlineStyle: errorMessage && (isIOS || isSafari ? 'solid' : 'auto'),
      outlineWidth: errorMessage && 2,
    },
    label: {
      flex: 1,
      fontSize: 14,
      marginLeft: 12,
      [theme.mq.desktop]: {
        fontSize: 16,
      },
    },
    span: {
      color: theme.colors.error,
      fontSize: 14,
      fontStyle: 'italic',
      marginLeft: 25,
      marginTop: 5,
    },
  })}
`;

export default StyledCheckbox;
